export default __webpack_public_path__ + "static/media/screen.1d077459.svg";